var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/validate-arguments-length.js
// module id = 262
// module chunks = 0 1